/* Liviory — comportamento da landing COD.
   Sem dependências. Três coisas: revelar secções, scroll até ao formulário,
   barra fixa em mobile. Mais do que isto atrasa a página. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. fade-up na entrada de cada secção */
  function reveal() {
    var items = document.querySelectorAll('.liv-reveal:not(.is-in)');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) { io.observe(el); });
  }

  /* 2. todos os CTAs levam ao formulário */
  function orderAnchor() {
    return document.getElementById('pedido');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-liv-scroll]');
    if (!trigger) return;

    var target = orderAnchor();
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

    // dá foco ao primeiro campo do formulário do app COD, se já estiver montado
    window.setTimeout(function () {
      var field = target.querySelector('input:not([type="hidden"]), select, textarea');
      if (field) field.focus({ preventScroll: true });
    }, reduced ? 0 : 600);
  });

  /* 3. barra fixa: aparece depois de 400px e some em cima do formulário */
  function stickyBar() {
    var bar = document.querySelector('[data-liv-sticky]');
    if (!bar) return;

    var ticking = false;

    function update() {
      ticking = false;
      var target = orderAnchor();
      var past = window.scrollY > 400;
      var atForm = false;

      if (target) {
        var box = target.getBoundingClientRect();
        atForm = box.top < window.innerHeight && box.bottom > 0;
      }

      bar.classList.toggle('is-visible', past && !atForm);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /* 4. play manual do vídeo, sem autoplay com som */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-liv-play]');
    if (!button) return;

    var video = button.parentElement.querySelector('video');
    if (!video) return;

    video.setAttribute('controls', 'controls');
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
    button.classList.add('is-hidden');
  });

  function init() {
    reveal();
    stickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // secções adicionadas no editor de tema também animam
  document.addEventListener('shopify:section:load', reveal);
})();
